// components/Gtag.jsx
import { useEffect } from 'react';
import { getOptions } from "@/api";

const Gtag = () => {
    useEffect(() => {
        let script;

        const loadGtag = async () => {
            try {
                const options = await getOptions();
                const gaId = options?.google_analytic || "";

                // Load the gtag.js script
                script = document.createElement('script');
                script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
                script.async = true;
                document.head.appendChild(script);

                // Initialize the gtag function
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                gtag('js', new Date());
                gtag('config', gaId);
            } catch (error) {
                console.error("Failed to fetch GA options:", error);
            }
        };

        loadGtag();

        // Cleanup the script if component unmounts
        return () => {
            if (script) {
                document.head.removeChild(script);
            }
        };
    }, []);

    return null; // No visual output
};

export default Gtag;
